import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Image, Typography } from 'tfc-components';

import line from 'assets/images/decor-title.png';
import products from 'assets/images/home/banner-line.png';
import logo from 'assets/images/icon-logo.png';
import Container from 'components/organisms/Container';
import Section from 'components/organisms/Section';

const Banner: React.FC = () => {
  const navigation = useNavigate();
  return (
    <Section className="p-home_banner">
      <Container>
        <div className="p-home_banner_logo">
          <Image imgSrc={logo} alt="EVOL Labs" ratio={100 / 116} />
        </div>
        <Typography.Heading
          type="h1"
          extendClasses="f-36x48 p-home_banner_title"
          fontweight="600"
          textStyle="center"
        >
          We Build AI-Native Products That Solve Real Problems
        </Typography.Heading>
        <Image extendClasses="p-home_banner_line" imgSrc={line} alt="EVOL Labs" ratio={51 / 3} />
        <Typography.Text
          type="p"
          extendClasses="f-20x24"
          textStyle="center"
        >
          EVOL LABS is a venture studio on a mission to turn bold
          ideas into scalable AI-powered products — fast, focused, and fearlessly.
        </Typography.Text>
        <Button onClick={() => navigation('/contact-us')} extendClasses="fButton p-home_banner_button">
          <Typography.Text fontweight="600">Work With Us</Typography.Text>
        </Button>
      </Container>
      <Image
        extendClasses="p-home_banner_products"
        imgSrc={products}
        alt="EVOL Labs Products"
        ratio={1366 / 164}
      />
    </Section>
  );
};

export default Banner;
